import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/typeSlice';
import { updateType } from 'slices/typeSlice';
import { addType } from 'slices/typeSlice';
import { typesSelector } from 'slices/typeSlice';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import PhoneInput from 'components/common/PhoneInput';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from 'components/common/FullPageLoader';
import LanguageTiers from './InterpreterRate';
import { usePermissions } from 'layouts/Admin';
import InterpreterRate from './InterpreterRate';


const AccountForm = ({ item }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions()

  const methods = useForm({});
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors, resetField } = methods;
  const { loader, error } = useSelector(typesSelector)
  const [status, setStatus] = useState(1);
  const [credentialsSend, setCredentialsSend] = useState(1);
  const [notification, setNotification] = useState(1);

  const resetAllFields = () => {
    setValue("name", "");
    setValue('email', '')
    setValue('password', '')
    setValue('phone', '');
    setNotification(1)

    setStatus(1)
  }

  useEffect(() => {
    setValue('name', item?.name || '');
    setValue('email', item?.email || '');
    setValue('password', '');
    setValue('phone', item?.phone || '');

    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
    setCredentialsSend((typeof (item?.user?.credentials_send) == "number") ? item?.user?.credentials_send : 1);
    setNotification((typeof (item?.user?.notifications) == "number") ? item?.user?.notifications : 1);

    dispatch(setError({}));

    return () => {
      resetAllFields();
    }

  }, [item])

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      resetAllFields()
      navigate(-1)
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    const newData = {
      ...data,
      status,
      credentialsSend,
      notification,
    };

    if (item?.id) {
      dispatch(updateType(newData, item?.id, submitCallback));
    } else {
      dispatch(addType(newData, submitCallback));
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form className='card_table p-4' onSubmit={handleSubmit(onSubmit)}>
          {/* Main credientials area  */}
          <div className='foam_page_row'>
            <div className="row-primary">
              <h2>Name *</h2>
              <div className='w-100'>
                <Controller
                  name="name"
                  rules={{
                    required: "Organization name is required"
                  }}
                  control={control}
                  render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' {...field} />}
                />
                {error?.errors?.name?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.name?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.name?.message} />
                  </div>
                }
              </div>
            </div>

            <div className="row-primary">
              <h2>Email *</h2>
              <div className='w-100'>
                <Controller
                  name="email"
                  rules={{
                    required: "Email is required"
                  }}
                  control={control}
                  render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" autoComplete="off" name='email'
                    pattern={
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                    }
                    placeholder="Email Address"
                    {...field}
                  />
                  }
                />
                {error?.errors?.email?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.email?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                }
              </div>
            </div>

            <div className="row-primary">
              <h2>Password {!item && '*'}</h2>
              <div className='w-100'>
                <Controller
                  name="password"
                  rules={
                    !item && {
                    required: "Password is required"
                  }}
                  control={control}
                  render={({ field }) =>
                    <input className={`input-in type_inp `} autoComplete="off" type="password" name='password' placeholder="Password" {...field}
                      disabled={watch("type") == "interpreter" ? true : false}
                    />}
                />
                {error?.errors?.password?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.password?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.password?.message} />
                  </div>
                }
              </div>
            </div>

            <div className="row-primary">
              <h2>Phone</h2>
              <div className='w-100'>
                <Controller
                  name="phone"
                  control={control}
                  render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""} `}
                    type="tel" name='contact' placeholder='Phone number' {...field} />
                  }
                />
                {error?.errors?.phone?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            </div>

            <div className="row-primary align-items-center">
              <h2 className='m-0'>Credentials will be sent over email</h2>
              <label className="custom-checkbox checkbox">
                <input
                  type="checkbox"
                  name="credentials_send"
                  checked={credentialsSend === 1 ? true : false}
                  onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div className="row-primary align-items-center">
              <h2 className='mt-0'>Notifications <span className='opacity-50'>(all type of notifications regarding appointments)</span></h2>
              <CustomSwitch
                labelText="notifications"
                checked={notification == 1 ? true : false}
                handleChange={(checked) => setNotification(checked ? 1 : 0)}
              />
            </div>
          </div>

          <InterpreterRate control={control} error={error} errors={errors} item={item} dispatch={dispatch} setValue={setValue} watch={watch} />

          <div className="Form-footer footer_fullpage">

            <div className="row-primary m-0 align-items-center">
              {checkPermission('Status Client Account') &&
                <>
                  <h2 className='mt-0'>Status</h2>
                  <CustomSwitch
                    labelText="active"
                    checked={status == 1 ? true : false}
                    handleChange={(checked) => setStatus(checked ? 1 : 0)}
                  />
                </>
              }
            </div>

            <SubmitButton
              loader={loader}
              btnText={item?.id ? "Update" : "Create"}
            />
          </div>
        </form>
      </FormProvider>

      {loader
        &&
        <FullPageLoader />
      }
    </>
  )
}

export default AccountForm;